module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyrightPage",
    attrs: {
      "id": "copyright"
    }
  }, [_c('p', {
    staticClass: "copyrightText3"
  }, [_vm._v("This edition of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("King of Airfighters")]), _vm._v(" is published in the United States of America in 2009 by")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("CASEMATE")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("908 Darby Road, Havertown, PA 19083")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("and in the United Kingdom by")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("CASEMATE")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("17 Cheap Street, Newbury, RG14 5DD")]), _vm._v(" "), _c('p', {
    staticClass: "centerImageC"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "id": "logo1",
      "src": "images/logo1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("This edition Copyright © 1989 & 2009 Lionel Leventhal Ltd,")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("Typeset & Design © 2009 Casemate Publishers")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("ISBN: 978-1-932033-99-1")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v(" Digital Edition ISBN: 978-1-935149-77-4")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("Cataloging in publication data is available from the Library of Congress and the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system or transmitted, in any form or by any means, electronic, mechanical, photocopying, recording or otherwise without the prior permission of the publishers.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("Printed and bound in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("908 Darby Road")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("Havertown PA, 19083")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("Publishing History:")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("King of Airfighters")]), _vm._v(" was first published by Ivor, Nicolson and Watson in 1934. It was reissued in facsimile by Greenhill Books/Lionel Leventhal Ltd in 1989. This new edition has been completely retypeset but the original language has been left unaltered.")]), _vm._v(" "), _c('p', {
    staticClass: "centerImageC"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "id": "logo2",
      "src": "images/logo2.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72dc8eb8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KingofAirfighters_copyright.vue
// module id = 63
// module chunks = 0